/*=============================
=           Dropzone          =
=============================*/

const { Dropzone } = require('dropzone');

var fileField = document.querySelector('.dropzone');

if(fileField) {
    var fileFieldId = fileField.parentNode.getAttribute('data-id'),
        maxFiles = fileField.getAttribute('data-max-files'),
        maxFilesize = fileField.getAttribute('data-max-filesize'),
        accepted = fileField.getAttribute('data-accepted'),
        fileDrop = new Dropzone('.dropzone', {
            maxFiles: maxFiles ? parseInt(maxFiles) : 1,
            maxFilesize: maxFilesize ? parseInt(maxFilesize) : 5,
            acceptedFiles: JSON.parse(accepted).join(','),
            autoProcessQueue: false,
            addRemoveLinks: true,
            url: '/process-form',
            dictDefaultMessage: 'Drag-and-drop files here or click to select from your computer'
        });
}

/*=============================
=        Clinical Trial       =
=============================*/

var conditions = document.querySelector('select#condition'),
    submitBtn = document.querySelector('#clinical-trial-form button[type="submit"]');

if(conditions) {
    var proceedBtn = document.getElementById('proceed-btn');

    conditions.addEventListener('change', function() {
        proceedBtn.style.display = this.value ? 'block' : 'none';

        if(!this.value)
            toggleClinicalTrialsDisplay(false);
    })

    proceedBtn.addEventListener('click', function() {
        proceedBtn.style.display = 'none';
        toggleClinicalTrialsDisplay(true);
    });
}

function toggleClinicalTrialsDisplay(display) {
    [].slice.call(document.querySelectorAll('#clinical-trial-form > div:not(:nth-child(2))')).forEach(function(row) {
        row.style.display = display ? 'block' : 'none';
    });

    submitBtn.style.display = display ? 'block' : 'none';
}

/*=============================
=         Form Process        =
=============================*/

var formMessage = document.getElementById('form-message');

[].slice.call(document.querySelectorAll('.ajax-form')).forEach(function(form) {
    form.addEventListener('submit', formProcess);
});

function formProcess(e) {
    if('performance' in window === false)
        return true;

    e.preventDefault();

    var form = this,
        data = new FormData(form),
        button = this.querySelector('button[type="submit"]');

    button.classList.add('disabled');

    // Add File Uploads to Form Data
    if(fileField && fileDrop) {
        var files = fileDrop.files.filter(function(f) { return f.accepted; });

        // For validation, if field is required
        if(files.length)
            data.append(fileFieldId, 'File(s) Uploaded');

        for(var f=0; f<files.length; f++)
            data.append(fileFieldId+f, files[f]);
    }

    data.append('c_time', performance.now() >= 7000 ? 0 : 1);

    axios.post(form.action, data)
        .then(function(r) {
            Velocity(form, 'slideUp', {duration: 500, delay: 500});
            clearErrors(form);
            formMessage.classList.add('success');
            formMessage.innerHTML = r.data.message;

            if(typeof dataLayer !== 'undefined')
                dataLayer.push({'event': 'FormSubmission'});
        })
        .catch(function (e) {
            setTimeout(function() {
                button.classList.remove('disabled');
            }, 500);

            console.log(e.response.data.errors);

            formMessage.classList.add('error');
            formMessage.innerHTML = e.response.data.message;

            if(e.response.status===422) {
                clearErrors(form);
                setErrors(form, e.response.data.errors);
            }
        });
}

function clearErrors(form) {
    var errors = form.getElementsByClassName('error');

    for(var e=errors.length - 1; e>=0; e--)
        errors[e].classList.remove('error');

    Velocity(formMessage, 'scroll', {
        duration: 500,
        offset: -header.offsetHeight
    });
}

function setErrors(form, errors) {
    var firstField = false;

    if(Object.keys(errors).length) {
        var errorsList = document.createElement('ul');

        formMessage.appendChild(errorsList);
    }

    for(var key in errors) {
        var label = form.querySelector('label[for="'+key+'"], fieldset[data-id="'+key+'"]');

        if(label)
            label.parentNode.classList.add('error');

        if(key == 'g-recaptcha-response')
            document.querySelector('.g-recaptcha').classList.add('error');

        var field = form.querySelector('*[name="'+key+'"], fieldset[data-id="'+key+'"] .dropzone');

        field.setAttribute('aria-describedby', key+'_error');

        if(!firstField) {
            field.focus();
            firstField = true;
        }

        var li = document.createElement('li');

        li.setAttribute('id', key+'_error');
        li.innerHTML = errors[key];
        errorsList.appendChild(li);
    }
}
